/**
 * planUrl.js — la regla de un plan tipo URL.
 *
 * QUÉ ES UN PLAN TIPO URL
 * -----------------------
 * Un plan con `planes.is_url = true` no se cotiza en Yool: la card lleva a
 * `planes.url`, el sitio de la compañía aseguradora. Un producto se comporta como
 * "tipo URL" cuando TODOS sus planes activos lo son — no hay columna de producto,
 * es derivado (`esProductoTipoUrl` en flow).
 *
 * POR QUÉ LA VALIDACIÓN VIVE ACÁ Y NO EN EL handleSubmit
 * ------------------------------------------------------
 * flow filtra los planes con `mapPlanesToUrlConfig` y descarta el que no tenga
 * una `url` no vacía que empiece con `https://`. Ese descarte es SILENCIOSO: el
 * plan simplemente no aparece en el cotizador, sin error en ningún lado. Si el
 * admin dejara guardar un plan tipo URL sin url —o con `http://`—, el resultado
 * sería un plan publicado que nadie ve y nada que explique por qué.
 *
 * O sea que estas dos funciones son la MISMA regla que el filtro de flow, escrita
 * del lado que puede avisar a tiempo. Si allá cambia el criterio, acá también.
 *
 * @see flow/src/lib/miniFormUrl.ts — `mapPlanesToUrlConfig`, el filtro espejo
 */

/** El prefijo que exige flow. `http://` se descarta igual que un string vacío. */
const ESQUEMA = 'https://';

const limpiar = (url) => (typeof url === 'string' ? url.trim() : '');

/**
 * @param {boolean} isUrl valor del toggle "Plan tipo URL"
 * @param {string|null|undefined} url
 * @returns {string|null} el motivo del rechazo, o `null` si se puede guardar.
 */
export function validarPlanUrl(isUrl, url) {
  if (!isUrl) return null;

  const limpia = limpiar(url);
  if (!limpia) {
    return 'Un plan tipo URL necesita la URL de destino.';
  }
  if (!limpia.startsWith(ESQUEMA)) {
    return `La URL de destino debe empezar con ${ESQUEMA} — flow descarta el plan si no.`;
  }
  return null;
}

/**
 * El valor que va a la columna `planes.url`.
 *
 * Apagar el toggle limpia la URL a propósito: un plan que dejó de ser tipo URL no
 * debe arrastrar el destino de la compañía, porque volver a encenderlo lo
 * republicaría hacia un sitio que quizá ya no corresponde.
 *
 * @param {boolean} isUrl
 * @param {string|null|undefined} url
 * @returns {string|null}
 */
export function urlParaGuardar(isUrl, url) {
  if (!isUrl) return null;
  return limpiar(url) || null;
}
